import {useCallback, useId, useRef, useState} from 'react';

import {uniqId} from '@pb/kit-util-uniq-id';
import {useCallbackWithRef} from '@pb/kit-util-use-callback-with-ref';


export const useTabs = (defaultValue: string) => {
    const [value, setValue] = useState<string>(defaultValue);
    const tabPanelId = useId();
    const tabsId = useRef(uniqId('tabs-'));
    const activeTabId = `${tabsId.current}-${value}`;

    const onChange = useCallbackWithRef((newValue: string) => {
        setValue(newValue);
    });

    const getTabsProps = useCallback(() => ({
        tabsId: tabsId.current,
        value,
        onChange,
        tabPanelId,
    }), [value, tabPanelId, onChange]);

    const getPanelProps = useCallback(() => ({
        'id': tabPanelId,
        'aria-labelledby': activeTabId,
    }), [tabPanelId, activeTabId]);

    return {
        value,
        setValue: onChange,
        getTabsProps,
        getPanelProps,
    };
};
